import create from 'zustand'

export const useStore = create((set:any) => ({
  stage: 0,
  percentage: 0,
  setStage: (s:any) => set((state:any) => ({ stage: s })),
  setPercentage: (p:any) => set((state:any) => ({ percentage: p }))
}))
